import React from 'react';
import config from '../../config';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, handleFavouriteItems, index, handleSocialShare, isOwnListing } = props;
  const images = listing.images;
  const { variantPrefix } = config.listing;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <ListingImageGallery
      indexValue={index}
      handleSocialShare={handleSocialShare}
      rootClassName={css.productGallery}
      handleFavouriteItems={handleFavouriteItems}
      listing={listing}
      images={images}
      imageVariants={imageVariants}
      thumbnailVariants={thumbnailVariants}
      isOwnListing={isOwnListing}
    />
  );
};

export default SectionGallery;
